import { render, staticRenderFns } from "./intellidataDeviceIORecord.vue?vue&type=template&id=5c40da7e&scoped=true&"
import script from "./intellidataDeviceIORecord.vue?vue&type=script&lang=js&"
export * from "./intellidataDeviceIORecord.vue?vue&type=script&lang=js&"
import style0 from "./intellidataDeviceIORecord.vue?vue&type=style&index=0&id=5c40da7e&scoped=true&lang=css&"
import style1 from "./intellidataDeviceIORecord.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c40da7e",
  null
  
)

export default component.exports